import { defineMessages } from 'utils/intl';

export default defineMessages({
  addToCompare: 'Dodaj do porównania',
  toCompare: 'Do porównania',
  addedToCompare: 'Dodano do porównania',
});
